import { appConfig } from '@ll-platform/frontend/config/app.config';

export function isDev(): boolean {
  return appConfig.REACT_APP_ENV === 'development';
}
